__turbopack_context__.v({
  "richHeadline": "TagPage-module-scss-module__s6vyDW__richHeadline",
  "richInnerDiv": "TagPage-module-scss-module__s6vyDW__richInnerDiv",
  "richTextDiv": "TagPage-module-scss-module__s6vyDW__richTextDiv",
  "title": "TagPage-module-scss-module__s6vyDW__title",
  "wrapper": "TagPage-module-scss-module__s6vyDW__wrapper",
});
